import React from 'react'
import { Modal } from 'react-bootstrap'
import {
  DOCUMENT_CATEGORY_DUI_IMAGE,
  DOCUMENT_CATEGORY_FRONT,
  DOCUMENT_CATEGORY_PASSPORT,
  DOCUMENT_CATEGORY_RESIDENT,
  DOCUMENT_CATEGORY_SELFIE,
} from '../../../config'
import './photoCompareModal.scss'

const PhotoCompareModal = (props) => {
  const { data, showModalCompare, toggleModalCompare, category } = props
  // this logic checks for 'front' and 'selfie' photos, preview display for id is larger than for selfie
  // there's an edge case, if document_type fields are empty, then it will compare the first and last photos
  let id = null
  let selfie = null
  let items = []
  if (data.length) {
    items = data.filter((i) => i.is_active)
    for (let i = 0; i < items.length; i++) {
      if (category === DOCUMENT_CATEGORY_DUI_IMAGE) {
        if (items[i].document_type === DOCUMENT_CATEGORY_SELFIE) {
          id = items[i].document
        }
        if (items[i].document_type === category) {
          selfie = items[i].document
        }
      } else if (category === DOCUMENT_CATEGORY_RESIDENT) {
        if (items[i].document_type === DOCUMENT_CATEGORY_SELFIE) {
          id = items[i].document
        }
        if (items[i].document_type === category) {
          selfie = items[i].document
        }
      } else {
        if (
          items[i].document_type === DOCUMENT_CATEGORY_FRONT ||
          items[i].document_type === DOCUMENT_CATEGORY_PASSPORT
        ) {
          id = items[i].document
        }
        if (items[i].document_type === category) {
          selfie = items[i].document
        }
      }
    }
  }
  if (!id && !selfie) {
    if (items.length) {
      id = items[0].document
      selfie = items[items.length - 1].document
    }
  }
  return (
    <Modal
      dialogClassName='photo-compare-modal'
      className='text-center'
      size={'lg'}
      aria-labelledby='contained-modal-title-sm'
      show={showModalCompare}
      onHide={() => {
        toggleModalCompare()
      }}
    >
      <div>
        <img src={id} width={'100%'} />
      </div>
      <div>
        <img src={selfie} width={'100%'} />
      </div>
    </Modal>
  )
}

export default PhotoCompareModal
